<template>
  <div class="default-modal" v-loading="loading">
    <el-dialog v-model="visible" top="5vh" width="55%" ; :title="displayTitle" @close="close"
      :close-on-click-modal="false">
      <div class="dialog-header">
        <span class="header-part"> ATTENTION! </span>
        <el-button size="medium" class="el-white" type="info" plain @click="close">
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" /></el-button>
      </div>
      <div class="icdAttentionPopup pb-0">
        <div class="icdAttentionPopupBlock" v-if="validationErrors">
          <ul class="attentionlists">
            <li class="eachLists" v-for="(error, index) in validationErrors" :key="index">
              <div class="icdValidations">
                <ul>
                  <li v-if="error.errorCode == 'BILLING_INFO_MISSING'">
                    <p class="pt-10" style="color: #ff4141">
                      {{ error.message }}
                    </p>
                  </li>
                  <li class="eachLists" v-if="error.errorCode == 'INSURANCE_VERIFICATION_FAILED'">
                    <div class="title">
                      
                      <h3 class="validation-headers">
                        INSURANCE VERIFICATION FAILED!
                      </h3>
                    </div>
                    <p class="para">
                      The insurance information provided for this order could not be verified due to reason: <br /> <span style="color: black; font-weight: 500; "> {{ error.errors ? error.errors.errorMessage : "" }}</span>
                    </p>
                  </li>
                  <template v-if="error.errorCode == 'PAYABLE_CODE_NOT_EXISTS' && index === firstICDErrorIndex">
                    <div class="title pt-10">
                      <h3 class="validation-headers">
                        ICD CODES ERROR!
                      </h3>
                    </div>
                    <p class="para">
                      The ICD code(s) provided for this test are not supportive of medical necessity for the ordered test(s). <br /> Please review and update with the appropriate ICD code(s). Suggested ICD codes related to this test are available for your reference.
                    </p>

                    <div class="topBlock">
                      <p>TEST INFO</p>
                      <p>ICD CODES</p>
                      <p>SELECTED ICD CODES</p>
                    </div>
                  </template>
                  <ul class="IcdErrorHorizontalBlock">
                    <li class="firstBlock" v-if="error.errorCode == 'PAYABLE_CODE_NOT_EXISTS'">
                      <div class="headerBlock">
                        <!-- <p class="label">
                        Relevant ICD Codes
                      </p> -->
                        <p class="value">{{ caseTypeDisplayName(error.errors.original.case_types)
                        }}</p>
                      </div>
                      <el-button class="suggestBtn" type="button"
                        @click="openSuggestedICDModal(error.errors.original.case_types)">
                        SUGGESTED ICD CODES
                      </el-button>
                      <div v-if="error.errors?.payable_codes?.length > 0">
                        <div style="display: flex;align-items: center;gap: 10px;">
                            <el-select
                              v-model="selectedICDCodesMap[error.errors.original.case_types]"
                              placeholder="Selected ICD Codes"
                              multiple
                              collapse-tags
                              :tag-props="{ closable: false }"
          
                            >
                              <el-option
                                v-for="(code, idx) in (selectedICDCodesMap[error.errors.original.case_types] || [])"
                                :key="idx"
                                :label="code"
                                :value="code"
                              />
                            </el-select>
                          </div>
                      </div>
                    </li>
                  </ul>
                </ul>
              </div>
            </li>
          </ul>
          <div class="attachment-upload" v-if="selectedFile">
            <a>
              <div class="content">
                <div class="icon">
                  <img src="@/assets/images/icons/attachments/attachments_0.svg" alt="icon" class="img-fluid" />
                </div>
                <div class="text">
                  <p>{{ this.selectedFile ? this.selectedFile.name : '' }}</p>
                </div>
              </div>

              <el-button class="remove-button" @click="removeFile">
                <el-icon>
                  <close />
                </el-icon>
              </el-button>

            </a>

          </div>

        </div>
        <div class="dialog-footer pt-0">
          <!-- <el-button
            class="blue-save-button cancel-button"
            @click="discardOrder"
            >Discard Order</el-button
          > -->
          <el-upload name="logo" action :on-change="uploadFile" :show-file-list="false" :auto-upload="false"
            accept=".pdf">
            <el-button class="blue-save-button" v-if="hasInsuranceError && insuranceErrorHasData" style="margin-right: 10px;">
              <span>
                 <img src="@/assets/images/icons/upload-file-white.svg" style="width: 16px;height: 16px;" alt="icon" class="img-fluid" />
              </span>
              UPLOAD </el-button>
          </el-upload>
          <el-button class="blue-save-button" style="margin-right: 0!important;" @click="close">UPDATE</el-button>
          <el-button class="blue-save-button success-button" @click="createCase"
            v-if="this.caseCreation">SAVE</el-button>
          <!-- <el-button
            class="blue-save-button"
            @click="createPendingOrder"
            v-if="this.createOrder"
            :loading="buttonLoading"
          >
            Create Pending Order</el-button
          > -->
          <el-button class="blue-save-button success-button" @click="moveToPending" v-if="this.createOrder"
            :loading="loading">SAVE</el-button>
          <el-button class="blue-save-button success-button" @click="createAccession" v-if="this.convert"
            :loading="loading">SAVE</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="default-modal order-reason-change-model">
      <el-dialog v-model="openNotesReasonsDialog" top="20vh" width="40%" title="Provide Reason and Notes"
        @close="handleCloseReason" :close-on-click-modal="false" :lock-scroll="false">
        <div class="dialog-header">
          <div class="header-part">
            <span>Notes and Reasons</span>
          </div>
          <el-button size="medium" class="el-white" type="info" plain @click="close">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
          </el-button>
        </div>
        <div class="popup-date pb-0">
          <el-form :model="reasonForm" :rules="reasonFormRules" ref="reasonForm">
            <el-form-item prop="reason">
              <el-select v-model="reasonForm.reason" placeholder="Select Reason" @change="updateNotes" multiple>
                <!-- Predefined reasons -->
                <el-option v-if="hasInsuranceError" label="Invalid Insurance" value="Invalid Insurance" />
                <el-option v-if="hasICDError" label="Unrelated ICD codes" value="Unrelated ICD codes" />
              </el-select>
            </el-form-item>
            <br />
            <el-form-item prop="notes">
              <el-input type="textarea" v-model="reasonForm.notes" placeholder="Enter additional notes"
                rows="3"></el-input>
              <p><b>Note :</b> Minimum 3 characters are required</p>
            </el-form-item>
          </el-form>
          <div class="dialog-footer">
            <el-button @click="handleCloseReason">CANCEL</el-button>
            <el-button type="primary" @click="submitReasonForm">SUBMIT</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
   <el-dialog v-model="showSuggestedICDModal" title="Suggested ICD Codes" width="40%" @close="closeSuggestedICDModal">
      <div class="dialog-header">
        <span class="header-part"> ICD & DESCRIPTION</span>
      </div>
      <div>
        <div class="all-cases-view">
          <div class="popup-date pb-0 pt-0">
             <div class="icd-search-block">
              <div class="form-element input-with-icon search-input-lg "> 
                  <el-input 
                   v-model="icdSearchQuery" placeholder="Search ICD Codes or Description"
                    clearable
                 class="icd-search" size="small"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </div>
            <div class="primary-content-view-new"  v-loading="loading">
              <div class="listings listings__table listings__all-cases" id="all-cases-listings">
                <el-table :data="filteredICDCodes"
                  style="width: 100%; border-collapse: separate; border-spacing: 0 5px;" height="300"
                  :row-class-name="tableRowClassName" :row-key="row => row.icd" @row-click="toggleRowSelection">
                  <el-table-column prop="icd" label="ICD Code" width="120">
                    <template #default="scope">
                      <span style="color: #273480;">{{ scope.row.icd }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="description" label="Description">
                    <template #default="scope">
                      <span>{{ scope.row.description }}</span>
                    </template>
                  </el-table-column>

                  <!-- this handles "no data found" case -->
                  <template #empty>
                    <div style="text-align:center; padding: 20px; color: #999;">
                      No data found
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-footer class="dialog-footer p-0">
        <el-button class="cancel-button" @click="closeSuggestedICDModal">
          CANCEL
        </el-button>
        <el-button class="blue-save-button" @click="confirmSuggestedICD">
          OK
        </el-button>

      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";

export default {
  props: [
    "validationErrors",
    "caseCreation",
    "convert",
    "createOrder",
    "caseInformation",
  ],
  data() {
    return {
      visible: true,
      currentWidth: "30%",
      formData: {
        reason: "",
      },
      reasonForm: {
        reason: "",
        notes: "",
      },
      reasonFormRules: {
        reason: [
          { required: true, message: "Reasons are required", trigger: "blur" },
        ],
        notes: [
          { required: true, message: "Notes are required", trigger: "blur" },
        ],
      },
      rules: {
        reason: [
          {
            required: true,
            message: "Invalid reason",
            pattern: /^.\S/,
            trigger: "blur",
          },
        ],
      },
      reasonDialogVisible: false,
      takeStatusChangeReasonDialogTitle: "PENDING",
      toStatus: "PENDING",
      loading: false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      orderID: "",
      openNotesReasonsDialog: false,
      predefinedOptions: {
        "Invalid Insurance":
          "Please provide valid insurance details along with a copy of the insurance.",
        "Unrelated ICD codes": "Please provide valid ICD codes.",
      },
      selectedFile: null,
      selectedICDCodes: [],
      selectedICDCodesMap: {}, // stores selection per case type
      showAllCodes: false,
      maxCodesVisible: 5,
      icd_codes_with_description: [],
      showSuggestedICDModal: false,
      suggestedICDSelected: [], // Stores selected ICD codes for the active case type
      activeCaseType: null, // Tracks the currently active case type
      icdSearchQuery: "",
    };
  },
  mounted() {
    if (this.width) {
      this.currentWidth = this.width + "%";
    }
    this.updateScrollLock();
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  computed: {
    ...mapGetters("orders", [
      "getUpdateOrderStatus",
      "getStatusMovingStatus",
      "getPendingOrderCreationStatus",
    ]),
    insuranceErrorHasData() {
      const error = this.validationErrors.find(e => e.errorCode === "INSURANCE_VERIFICATION_FAILED");
      return error && error.errors && Object.keys(error.errors).length > 0;

    },
    filteredICDCodes() {
      if (!this.icdSearchQuery) {
        return this.icd_codes_with_description;
      }

      const query = this.icdSearchQuery.toLowerCase();
      const matches = this.icd_codes_with_description.filter(
        item =>
          item.icd.toLowerCase().includes(query) ||
          item.description.toLowerCase().includes(query)
      );
      // if no matches, return empty handled by slot
      return matches;
    },
    selectedICDCodesDisplay() {
      return this.selectedICDCodes.join(', ');
    },
    getCaseTypeMapped(case_type) {
      return this.caseTypeMap[case_type] || "";
    },
    checkReason() {
      if (
        this.formData.reason &&
        this.formData.reason.trim() &&
        this.formData.reason.trim().length &&
        this.formData.reason.trim().length >= 3
      ) {
        return false;
      }

      return true;
    },
    hasInsuranceError() {
      return this.validationErrors.some(
        (error) => error.errorCode === "INSURANCE_VERIFICATION_FAILED"
      );
    },
    firstICDErrorIndex() {
      return this.validationErrors.findIndex(
        (e) => e.errorCode === "PAYABLE_CODE_NOT_EXISTS"
      );
    },
    hasICDError() {
      return this.validationErrors.some(
        (error) => error.errorCode === "PAYABLE_CODE_NOT_EXISTS"
      );
    },
  },
  methods: {
    updateScrollLock() {
      if (this.visible || this.openNotesReasonsDialog || this.showSuggestedICDModal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    showAllICDSuggestions() {
      // Show all ICD codes when input is focused and query is empty
      if (!this.icdSearchQuery) {
        this.$refs.icdAutocomplete && this.$refs.icdAutocomplete.focus();
        // Use callback to show all codes
        this.getAutoCompleteICDData('', suggestions => {
          // Manually open dropdown with all suggestions
          this.$refs.icdAutocomplete.suggestions = suggestions;
          this.$refs.icdAutocomplete.visible = true;
        });
      }
    },
    openSuggestedICDModal(caseType) {
      let icdCodesWithDescription = [];
      if (this.validationErrors && caseType) {
        const icdError = this.validationErrors.find(
          e => e.errorCode === 'PAYABLE_CODE_NOT_EXISTS' && e.errors.original?.case_types === caseType
        );
        if (icdError?.errors) {
          icdCodesWithDescription = icdError.errors.icd_codes_with_description || [];
        }
      }

      this.icd_codes_with_description = icdCodesWithDescription;
      this.activeCaseType = caseType;

      // Load only this case type’s selection
      this.suggestedICDSelected = (this.selectedICDCodesMap[caseType] || []).map(code => ({
        icd: code,
        case_type: caseType
      }));

      this.showSuggestedICDModal = true;
    },

    closeSuggestedICDModal() {
      this.showSuggestedICDModal = false;
      this.activeCaseType = null;
      this.suggestedICDSelected = []; // Reset on close
      this.icdSearchQuery = "";
    },

    toggleRowSelection(row) {
      const idx = this.suggestedICDSelected.findIndex(
        i => i.icd === row.icd && i.case_type === this.activeCaseType
      );
      if (idx > -1) {
        // Deselect the row if already selected
        this.suggestedICDSelected.splice(idx, 1);
      } else {
        // Select the row
        this.suggestedICDSelected.push({
          icd: row.icd,
          case_type: this.activeCaseType
        });
      }
      this.icdSearchQuery = "";
    },

    tableRowClassName({ row }) {
      // Apply a custom class to visually indicate selected rows
      return this.suggestedICDSelected.some(
        i => i.icd === row.icd && i.case_type === this.activeCaseType
      )
        ? 'selected-row'
        : '';
    },

    confirmSuggestedICD() {
      if (!this.activeCaseType) return;

      // Save only for the active case type
      this.selectedICDCodesMap = {
        ...this.selectedICDCodesMap,
        [this.activeCaseType]: this.suggestedICDSelected.map(icd => icd.icd)
      };

      // Update global flat list for display if needed
      this.selectedICDCodes = Object.values(this.selectedICDCodesMap).flat();

      this.showSuggestedICDModal = false;
      this.activeCaseType = null;
      this.suggestedICDSelected = [];
    },

    toggleICDCode(caseType, code, event) {
      if (!this.selectedICDCodesMap[caseType]) {
        this.selectedICDCodesMap[caseType] = [];
      }
      const arr = this.selectedICDCodesMap[caseType];
      if (arr.includes(code)) {
        this.selectedICDCodesMap[caseType] = arr.filter(c => c !== code);
      } else {
        this.selectedICDCodesMap[caseType].push(code);
      }
      // Remove focus immediately so Element UI doesn't keep the 'active' color
      if (event && event.target) {
        event.target.blur();
      }
    },
    removeFile() {
      this.selectedFile = null;
    },
    uploadFile(file) {
      // Element Plus passes {file, ...} object, so use file.raw if present
      const realFile = file.raw || file;
      const isPDF =
        (realFile.type === 'application/pdf' || realFile.type === 'application/x-pdf') &&
        realFile.name.toLowerCase().endsWith('.pdf');
      if (!isPDF) {
        this.$notify({
          type: 'error',
          title: 'File Format Error',
          message: 'Only PDF files are allowed.'
        });
        return;
      }
      if (realFile.size === 0) {
        this.$notify({
          type: 'error',
          title: 'Empty File',
          message: 'Uploaded file is empty.'
        });
        return;
      }
      const MAX_SIZE = 2 * 1024 * 1024;
      if (realFile.size > MAX_SIZE) {
        this.$notify({
          type: 'error',
          title: 'File Size Error',
          message: 'File size exceeds the maximum allowed limit.'
        });
        return;
      }
      this.selectedFile = realFile;
    },
    caseTypeDisplayName(caseType) {
      return this.caseTypeMap[caseType] || caseType;
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.visible = false;

          this.$emit("reasonSubmit", this.formData.reason);
        } else {
          return false;
        }
      });
    },
    close() {
      this.$emit("close");
    },
    discardOrder() {
      window.location.reload();
    },
    async createPendingOrder() {
      try {
        this.reasonDialogVisible = true;
        this.populateReasonAndNotes();
      } catch (err) { }
    },
    populateReasonAndNotes() {
      let reason = "";
      let notes = "";

      const hasInsuranceError = this.validationErrors.some(
        (error) => error.errorCode === "INSURANCE_VERIFICATION_FAILED"
      );
      const hasICDError = this.validationErrors.some(
        (error) => error.errorCode === "PAYABLE_CODE_NOT_EXISTS"
      );

      if (hasInsuranceError && hasICDError) {
        reason = "Billing info & ICD Codes invalid";
        notes = "Subscriber not found & ICD codes are invalid";
      } else if (hasInsuranceError) {
        reason = "Billing info is invalid";
        notes = "Subscriber not found";
      } else if (hasICDError) {
        reason = "ICD Code is invalid";
        notes = "ICD codes are invalid for this casetype";
      }

      this.reasonForm.reason = reason;
      this.reasonForm.notes = notes;
    },
    openReasonDialog() {
      this.visible = false;
      this.reasonDialogVisible = true;
    },
    moveToPending() {
      // Get all arrays of ICD codes from the map (one array per case type)
      const icdCodeGroups = Object.values(this.selectedICDCodesMap);

      // Merge all groups into a single array
      const mergedIcdCodes = icdCodeGroups.flat();

      // Remove duplicate ICD codes
      const allSelectedIcdCodes = mergedIcdCodes.filter(
        (code, index, allCodes) => allCodes.indexOf(code) === index
      );

      let notMatchedICDCodes = [];
      this.validationErrors.forEach(err => {
        if (err.errorCode === "PAYABLE_CODE_NOT_EXISTS" && err.errors?.not_matched_values) {
          notMatchedICDCodes = notMatchedICDCodes.concat(err.errors.not_matched_values);
        }
      });
      //  Trigger success only if ICD codes are selected
      if (allSelectedIcdCodes.length > 0) {
        this.$notify({
          type: "success",
          title: "Success",
          message: "ICD codes are validated",
        });
      }
      this.visible = false;
      // Emit the event with the combined list of ICD codes
      this.$emit("approveOrder", false, this.selectedFile, true, allSelectedIcdCodes, notMatchedICDCodes);
    },
    createCase() {
      this.visible = false;
      this.$emit("moveCase", false);
    },
    createAccession() {
      // this.visible = false;
      this.openNotesReasonsDialog = true;
    },
    handleCloseReason() {
      this.openNotesReasonsDialog = false;
    },
    async submitReasonForm() {
      this.$refs.reasonForm.validate(async (valid) => {
        if (valid) {
          const data = {
            reasons: this.reasonForm.reason,
            notes: this.reasonForm.notes,
          };
          this.openNotesReasonsDialog = false;

          this.$emit("accessionCreation", data);

          // await this.moveStatus(data);
        }
      });
    },
    async moveStatus(params) {
      try {
        this.loading = true;
        params.id = this.$route.params.order_id || this.orderID;
        await this.$store.dispatch(
          "orders/checkInsuranceVerification",
          params,
          {
            root: true,
          }
        );
        if (this.getStatusMovingStatus && this.getStatusMovingStatus.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getStatusMovingStatus.message,
          });
          this.openNotesReasonsDialog = false;
          this.$emit("approveOrder", false, this.selectedICDCodes);
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async updateStatus(data) {
      try {
        let param = this.caseInformation;
        this.loading = true;

        await this.$store.dispatch("orders/pedningOrderCreation", param);
        if (this.getPendingOrderCreationStatus) {
          this.orderID = this.getPendingOrderCreationStatus._id;
          let params = {
            id: this.$route.params.order_id || this.orderID,
            status: this.toStatus,
            notes: data.notes,
            reasons: data.reasons,
          };
          await this.$store.dispatch("orders/changeOrderStatus", params, {
            root: true,
          });
          if (this.getUpdateOrderStatus && this.getUpdateOrderStatus.success) {
            this.$notify({
              type: "success",
              title: "Success",
              message: this.getUpdateOrderStatus.message,
            });
            this.$router.push({
              name: "ActiveOrders",
            });
          }
        } else {
          this.close();
        }

        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    updateNotes() {
      const actions = this.reasonForm.reason
        .map((reason) => this.predefinedOptions[reason])
        .filter((action) => action);
      this.reasonForm.notes = actions.join("\n");
    },
  },
  watch: {
    visible(val) {
      this.updateScrollLock();
    },
    openNotesReasonsDialog(val) {
      this.updateScrollLock();
    },
    showSuggestedICDModal(val) {
      this.updateScrollLock();
    }
  },
};
</script>

<style lang="scss" scoped> 
.icd-search .el-input__wrapper {
  min-height: 32px !important; /* medium height */
  height: 32px !important;
  border-radius: 6px;          /* optional: rounded look */
}

.icd-search .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  font-size: 10px; /* medium font */
}

.icd-search-block {
    display: flex;
    justify-content: end;
    margin-right: 1rem;
    
}
.form-element.input-with-icon{
    width: 150px;
    text-align: center;
    min-width: 40%; 
}
.validation-headers { 
      color:#ff4141;
      align-items: center;
      display: flex;
      font-size: 14px;
      font-weight: 600;
}
.icd-code-buttons-block {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  align-items: center;
  margin-bottom: 1rem;
  max-height: 115px;
  height: auto;
  overflow: auto;

  .icd-btn,
  .icd-btn.el-button--primary {
    min-width: 90px;
    width: 90px;
    margin-left: 0;
    font-weight: 500;
    border-radius: 6.4px;
  }


  .icd-btn:hover,
  .icd-btn:focus {
    outline: none;
    box-shadow: none;
  }

  .icd-btn.el-button--primary {
    color: #fff !important;
    background: #273480 !important;
    border-color: #273480 !important;
  }

  .icd-btn.el-button--primary:hover {
    filter: brightness(1.1);
  }


}

.icdAttentionPopup {
  .icdAttentionPopupBlock {
    .attachment-upload {
      padding: 10px 0 0;

      a {
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: 10px;
        border: 0.5px solid #e0e0e0;
        border-radius: 4px;
        padding: 3px 5px 3px 10px;

        .content {
          align-items: center;
          display: flex;

          .icon {
            margin-right: 10px;

            img {
              width: 10px;
              margin-bottom: -5px;
            }
          }

          p {
            line-height: 18px;
            color: #828282;
            // white-space: nowrap;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        button {
          margin-top: 1px;
          padding: 0;
          min-height: 0;
          border: none;
          width: 35px;
          height: 21px;

          i {
            font-weight: 800;
            font-size: 15px;
            color: #fff;
          }

          &.remove-button {
            background: #273480;
          }

          &.upload-button {
            background: #f24a55;
          }
        }
      }
    }
  }
}

.default-modal .dialog-footer {
  justify-content: center;
}

.IcdErrorHorizontalBlock {
  display: flex;
  align-items: center;
  column-gap: 10px;

  .firstBlock {
    display: flex;
    align-items: center;
    column-gap: 10px;
    width: 100%;
    justify-content: space-between;

  }
}
.icd-popup-headers {
  color: #273480;
}

:deep(.el-table__row) {
  cursor: pointer;
  height: 30px!important;

}

// remove default hover highlight
:deep(.el-table__body tr:hover > td) {
  background-color: transparent !important;
}

// custom selected row style (applied only on click)
:deep(.selected-row) {
  background-color: #ebecec !important;
  color: #090909 !important;
}

:deep(.el-table__body) {
  border-collapse: separate !important;
  border-spacing: 0 6px !important; /* space between rows */
}
</style>